import { makeStyles } from '@material-ui/core/styles'

export const useGlobalStyles = makeStyles({
  '@global': {
    '.pulse': {
      animation: '$pulse 3s ease infinite'
    },
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(1.2)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  }
})
